import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import { Redirect as AppRedirect } from 'wanderu-component-react-router-link';

const AboutUsPage = withInterstitial(import('./components/AboutUs/AboutUs'));
const CareersPage = withInterstitial(import('./components/Careers/Careers'));

export default [
    {
        path: '/about-us/',
        exact: true,
        component: AboutUsPage,
        key: '/about-us/',
    },
    {
        path: '/about-us/careers',
        exact: true,
        component: CareersPage,
        key: '/about-us/careers',
    },
    {
        path: '/about-us/careers/:job',
        component: CareersPage,
        key: '/about-us/careers/job-posting',
    },
    {
        path: '/about-us/*',
        key: 'about-us-catchall',
        component: () => {
            return (
                <AppRedirect href="/about-us/" />
            );
        },
    },
];
